export const AccessTokenKey = 'accessToken'
export const RefreshTokenKey = 'refreshToken'
export const AcademyData = 'academyData'



